import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { SpinButton } from 'office-ui-fabric-react/lib-commonjs/SpinButton';
import { Toggle } from 'office-ui-fabric-react/lib-commonjs/Toggle';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib-commonjs/Button';
import { Dialog, DialogFooter, DialogType } from 'office-ui-fabric-react/lib-commonjs/Dialog';
import {
  endVolumeOptimizer,
  getScaledValue,
  setCalculatedVolume,
  setParameterValue,
  setResultingOptimizedRows,
  setShowGenerateAlert,
  startSystemGeneration,
  startVolumeOptimizer,
  switchPorousStorage,
  switchUnderdrain,
} from '../../actions/calculations-actions';
import {
  applyManifoldSeparations,
  calculateManifoldSeparations,
  getManifoldMetadata,
  getManifolds,
} from '../../actions/manifold-actions';
import { setConstraints } from '../../actions/constraints-actions';
import CalculationsLib from '../../lib/calculations';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import './index.css';
import AppToolbar from '../Toolbars/app-toolbar';
import PopUpHelper from './popUpHelper.component';
import PipeParameters from '../LeftMenu/SystemParameters/Pipes/pipeParameters.container';
import { modalAlertActions } from '../../actions/modal-alert.actions';
import {
  CHAMBER_TYPE_ID_SC310,
  CHAMBER_TYPE_ID_SC740,
  CHAMBER_TYPE_ID_C100HD,
  GLOBAL_PROJECT_TYPE_CHAMBER,
  IMPERIAL,
  METRIC,
  OUTLET_MANIFOLD_ID,
  STONE_ABOVE_TABLE,
  STONE_BELOW_TABLE,
} from '../../lib/types';
import { getManifoldSizing } from '../../lib/manifolds';
import { cloneChamberRows } from '../../lib/chamber-row';
import { switchIsSigningInProcess } from '../../actions/authentication-actions';
import { switchProductType } from '../../actions/product-type.actions';
import { generatePipeDesign } from '../../actions/pipe-bed-actions';
import {
  resetAppState,
  resetBasicAppState,
  switchClearDialogVisibility,
  switchCreateDialogVisibility,
} from '../../actions/apptoolbar-actions';
import { regionIds } from '../../lib/localization/regionIds';
import { getStructureTypesByVolume } from '../../lib/manifolds/utils';
import { clearRulersOnScreen } from '../../actions/drawingtoolbar-actions';
import { languageIds } from '../../lib/localization/languageIds';
import ManifoldSelectors from '../../reducers/main-manifold-reducer';
import ChamberBedSelectors from '../../reducers/chamber-bed-reducer';
import IsolatorService from '../../lib/services/isolator_service';
import { calculatePolygonArea } from '../../lib/chamberBed/utils';
import ProjectSelectors from '../../reducers/project-reducer';
import { setImperviousLiner } from '../../actions/chamber-actions';
import { setDisableLayerLoginDialog } from '../../actions/generic-globals.actions';
import { setOverallTotal } from '../../actions/multi-bed-actions';

/**
 * Renders the form inside the System Parameters on the left menu
 */
class Calculations extends PureComponent {
  INITIAL_LOCAL_STATE = {
    errorDialogHidden: true,
    errorDialogMessage: '',
    optimizing: false,
    changeColor: true,
    showModalConfirm: false,
    customModal: {
      show: false,
      title: '',
      text: '',
    },
    includeImperviousLinerWaring1: false,
    includeImperviousLinerWaring2: false,
    includeImperviousLinerWaring3: false,
    includeImperviousLinerWaring4: false,
    includeImperviousLinerWaringError: false,
    showAvgCoverAlert: false,
  };

  state = this.INITIAL_LOCAL_STATE;

  componentDidMount() {
    const { storageVolume, totalStorageProvided } = this.props;
    this.props.applyManifoldSeparations(totalStorageProvided || storageVolume);
    this.props.setConstraints(this.props.chamberType, this.props.underdrain, true);
  }

  componentDidUpdate(prevProps) {
    // If chamber type/underdrain has changed, set the constraints
    const hasProjectTypeChanged = this.anyPropHasChanged(prevProps, ['projectType']);
    const hasChamberTypeChanged = this.anyPropHasChanged(prevProps, ['chamberType']);
    const hasUnderdrainChanged = this.anyPropHasChanged(prevProps, ['underdrain']);

    if (hasProjectTypeChanged || hasChamberTypeChanged || hasUnderdrainChanged) {
      this.props.setConstraints(this.props.chamberType, this.props.underdrain, hasChamberTypeChanged);
    }

    if (hasProjectTypeChanged) {
      this.props.modalAlertActions({
        toggle: true,
        text: this.props.content[this.props.lang].projectTypeSwitchWarning,
      });
    }

    if (hasProjectTypeChanged && this.props.backgroundImage) {
      this.props.modalAlertActions({
        toggle: true,
        text: this.props.content[this.props.lang].checkYourBackgroundScale,
      });
    }

    // Llamar aquí el nuevo dialogo
    if (
      this.anyPropHasChanged(prevProps, [
        'chamberRows',
        'chamberType',
        'chamberEndCapType',
        'chamberRowSpacing',
        'sepDistance',
        'storageVolume',
        'structureSize',
        'manifoldSize',
        'manifoldStructures',
        'manifoldPipeSizes',
      ])
    ) {
      const { storageVolume, totalStorageProvided } = this.props;

      this.props.applyManifoldSeparations(totalStorageProvided || storageVolume);
    }

    /* the properties to be checked */
    let names = [
      /* external components properties */
      'stoneBedPoints',
      'chamberRows',
      'chamberType',
      'chamberEndCapType',
      'chamberRowSpacing',
      /* provided parameters */
      'limitingLength',
      'limitingWidth',
      'invertDepth',
      'numberOfHeaders',
      'headerDiameter',
      'spacingBetweenChambers',
      'porousStoneWidthAtSides',
      'porousStoneWidthAtEnds',
      'porousStoneAbove',
      'porousStoneBelow',
      'porosityPercent',
      'porousStorageBetweenChambers',
      'structureDistance',
      'manifoldSize',
      'structureSize',
      'manifoldStructures',
      'manifoldPipeSizes',
      'hasImperviousLiner',
    ];

    /* the chamber rows property */
    let chamberRows = this.props.chamberRows;
    /* if any of the 'names' fields have changed, recompute calculations */
    if (
      (this.anyPropHasChanged(prevProps, names) || this.props.rerunCalculations) &&
      chamberRows.length &&
      chamberRows[0].getActiveCount &&
      this.props.stoneBedPoints.length
    ) {
      setTimeout(() => {
        this.executeAutoCalculations();
      });
    }

    /* Do something if volume changes */
    if (this.anyPropHasChanged(prevProps, ['optimizeVolume'])) {
      // force 1 row chamberbed to switch outlet and underdrain off
      if (chamberRows.length === 1) {
        if (this.props.underdrain || this.props.hasOutlet) {
          // FORCING hasOutlet to true even when volume is not optimal as requested since every system needs an OutLet
          this.props.setParameterValue('hasOutlet', true);
          this.props.switchUnderdrain();
          this.props.modalAlertActions({
            toggle: true,
            text: this.props.content[this.props.lang].outletToggledOffForSingleRow,
            showAsHtml: true,
            addClassName: 'taller-alert',
            overrideTextAlign: 'left',
          });
        }
      }
      if (this.props.optimizeVolume) {
        this.props.applyManifoldSeparations(this.props.storageVolume);
        const storageVolume = this.props.storageVolume;
        this.optimizePerChamber()
          .then((optimizedStorageVolume) => {
            if (optimizedStorageVolume < storageVolume) {
              this.showModal();
            }
          })
          .finally(() => {
            this.props.endVolumeOptimizer();
          })
          .catch((error) => {
            console.warn('There was a problem optimizing the system', error);
          });
      }

      this.setState({
        optimizing: this.props.optimizeVolume,
      });
    }

    // controls that the objects on systemParams are copied as they needed to calculations when chamberType changes
    // Will sync values to the data store after changing chamber
    const setStoreValuesChamberType = (paramValue) => {
      const sysParamObj = this.props.sysParam[paramValue];
      if (typeof sysParamObj === 'object' && sysParamObj.touched === true && sysParamObj.type === 'chamber') {
        this.props.setParameterValue(paramValue, sysParamObj.value);
      }
      // reset this values if chamber changes
      if (paramValue === 'porousStoneAbove' || paramValue === 'porousStoneBelow') {
        let pValue = sysParamObj[paramValue];
        if (!pValue) pValue = this.props.minimums[paramValue];
        this.props.setParameterValue(paramValue, pValue);
      }
    };

    // Will sync values to the data store after switching
    const setStoreValuesSyncOnSwitch = (paramValue) => {
      const sysParamObj = this.props.sysParam[paramValue];
      if (typeof sysParamObj === 'object' && sysParamObj.sync === true) {
        const syncToSysParamObj = this.props.sysParam[sysParamObj.syncTo];
        if (
          syncToSysParamObj.touched &&
          syncToSysParamObj.stamp > sysParamObj.stamp &&
          syncToSysParamObj.value !== sysParamObj.value &&
          sysParamObj.type === 'chamber'
        ) {
          this.props.setParameterValue(paramValue, syncToSysParamObj.value);
        }
      }

      if (
        (paramValue === 'porousStoneAbove' || paramValue === 'porousStoneBelow') &&
        this.props.minimums[paramValue] !== prevProps.minimums[paramValue]
      ) {
        let pValue = sysParamObj[paramValue];
        if (!pValue) pValue = this.props.minimums[paramValue];
        this.props.setParameterValue(paramValue, pValue);
      }
    };
    // Sync the values according to Switch or Chamber change
    for (const param in this.props.sysParam) {
      if (this.props.chamberType !== prevProps.chamberType) {
        setStoreValuesChamberType(param);
      } else {
        setStoreValuesSyncOnSwitch(param);
      }
    }
    if (ManifoldSelectors.bedHasOutlet() === false && this.props.hasImperviousLiner === true) {
      this.props.setParameterValue('hasImperviousLiner', false);
      this.props.setImperviousLiner(false);
    }
  }

  async optimizePerChamber() {
    let chamberRows = await this.lessOptimizedChambers();

    this.props.setResultingOptimizedRows(chamberRows);
    this.setState({
      optimizing: false,
    });

    return this.calculateVolume(this.executeCalculations(chamberRows, true));
  }

  async lessOptimizedChambers() {
    let chamberRows = cloneChamberRows(this.props.chamberRows);
    let numberOfChambers = chamberRows[0].chambers.length;

    const previousVolume = this.calculateVolume(this.executeCalculations(chamberRows));
    const { inletStructureType: previousInletStructureType, outletStructureType: previousOutletStructureType } =
      await this.refreshOptimizationCalculations(previousVolume, chamberRows);

    this.reassessStructureTypes(chamberRows, previousInletStructureType, previousOutletStructureType);

    if (this.props.storageVolume === 0) {
      return chamberRows;
    }

    try {
      while (true) {
        if (numberOfChambers === 1) {
          // You have a single column of chambers; I won't remove it any further!
          return chamberRows;
        }

        for (let i = chamberRows.length - 1; i >= 0; --i) {
          let chamberRow = chamberRows[i];

          let lastActiveChamber = chamberRow.getLastActiveChamber(),
            { active, lowerCapActive, lowerCapAccessory } = lastActiveChamber,
            lastActiveChamberProps = {
              active,
              lowerCapActive,
              lowerCapAccessory,
            };

          // Try removing the chamber.
          chamberRow.modifyChamber(
            {
              active: false,
              lowerCapActive: false,
              lowerCapAccessory: null,
            },
            lastActiveChamber.col,
          );

          // Now get the new last active chamber and apply properties
          let nextLastActiveChamber = chamberRow.getLastActiveChamber(),
            {
              active: nextActive,
              lowerCapActive: nextLowerCapActive,
              lowerCapAccessory: nextLowerCapAccessory,
            } = nextLastActiveChamber,
            nextLastActiveChamberProps = {
              active: nextActive,
              lowerCapActive: nextLowerCapActive,
              lowerCapAccessory: nextLowerCapAccessory,
            };

          chamberRow.modifyChamber(lastActiveChamberProps, nextLastActiveChamber.col);

          let assumedVolume = this.calculateVolume(this.executeCalculations(chamberRows));

          // In case the structures change...
          const calculations = await this.refreshOptimizationCalculations(assumedVolume, chamberRows);
          const { inletStructureType, outletStructureType } = getStructureTypesByVolume(
            calculations.volume,
            this.props.chamberType,
          );

          assumedVolume = calculations.volume;

          if (assumedVolume <= this.props.storageVolume) {
            // Reapply the two chambers' properties we are working with at a time
            chamberRow.modifyChamber(nextLastActiveChamberProps, nextLastActiveChamber.col);
            chamberRow.modifyChamber(lastActiveChamberProps, lastActiveChamber.col);

            return chamberRows;
          }

          // Apply new structure types to chamber bed
          this.reassessStructureTypes(chamberRows, inletStructureType, outletStructureType);
        }

        --numberOfChambers;
      }
    } catch (exception) {
      console.warn('There was an issue with optimizing the results', exception);
    }
    return cloneChamberRows(this.props.chamberRows);
  }

  async refreshOptimizationCalculations(assumedVolume, chamberRows) {
    // Check to get the more accurate volume if the structure changes
    chamberRows = cloneChamberRows(chamberRows);

    const { inletStructureType, outletStructureType } = getStructureTypesByVolume(
      assumedVolume,
      this.props.chamberType,
    );
    // this.props.calculateManifoldSeparations(assumedVolume, this.props.chamberType)
    //   .manifoldSizing;

    try {
      const firstActiveChamber = chamberRows[0].getFirstActiveChamber();
      const lastActiveChamber = chamberRows[chamberRows.length - 1].getLastActiveChamber();

      let changed = false;
      if (
        firstActiveChamber &&
        firstActiveChamber.upperCapActive &&
        firstActiveChamber.upperCapAccessory &&
        firstActiveChamber.upperCapAccessory.variant !== inletStructureType
      ) {
        const upperCapAccessory = {
          ...firstActiveChamber.upperCapAccessory,
          variant: inletStructureType,
        };
        chamberRows[firstActiveChamber.row].modifyChamber({ upperCapAccessory }, firstActiveChamber.col);
        changed = true;
      }

      if (
        lastActiveChamber &&
        lastActiveChamber.lowerCapActive &&
        lastActiveChamber.lowerCapAccessory &&
        lastActiveChamber.lowerCapAccessory.variant !== outletStructureType
      ) {
        const lowerCapAccessory = {
          ...lastActiveChamber.lowerCapAccessory,
          variant: outletStructureType,
        };
        chamberRows[lastActiveChamber.row].modifyChamber({ lowerCapAccessory }, lastActiveChamber.col);
        changed = true;
      }

      if (changed) {
        assumedVolume = this.calculateVolume(this.executeCalculations(chamberRows));
      }
    } catch (exception) {
      console.warn(exception);
    }

    return {
      volume: assumedVolume,
      inletStructureType,
      outletStructureType,
    };
  }

  showModal() {
    this.setState({ showModalConfirm: true });
  }

  roundNumber(num) {
    return Math.round(num * 100) / 100;
  }

  /**
   * This method receives the previous properties object and an Array of
   * the properties to be determined if have changed and returns true if any
   * have changed, or false if all are the same.
   *
   * @param {Object} prevProps The previous properties of the component.
   * @param {Array<string>} propNames The Properties names array.
   */
  anyPropHasChanged(prevProps, propNames) {
    let changed = false;
    for (let name of propNames) {
      changed = this.props[name] !== prevProps[name] || changed;
    }
    return changed;
  }

  calculateVolume(params) {
    /* the current calculations */
    let calculations = params.calculations;
    /* Just return the already calculated volume */
    //return Promise.resolve(calculations.installedStorageVolume);
    return calculations.installedStorageVolume;
  }

  reassessStructureTypes(chamberRows, inletStructureType, outletStructureType) {
    const _firstActiveChamber = chamberRows[0].getFirstActiveChamber();
    const _lastActiveChamber = chamberRows[chamberRows.length - 1].getLastActiveChamber();
    if (_firstActiveChamber.upperCapAccessory) {
      const upperCapAccessory = {
        ..._firstActiveChamber.upperCapAccessory,
        variant: inletStructureType,
      };
      chamberRows[_firstActiveChamber.row].modifyChamber({ upperCapAccessory }, _firstActiveChamber.col);
    }
    if (_lastActiveChamber.lowerCapAccessory) {
      const lowerCapAccessory = {
        ..._lastActiveChamber.lowerCapAccessory,
        variant: outletStructureType,
      };
      chamberRows[_lastActiveChamber.row].modifyChamber({ lowerCapAccessory }, _lastActiveChamber.col);
    }
  }

  executeAutoCalculations() {
    /* execute autocalculations(each time a user changes something) */
    let calculations = this.executeCalculations(this.props.chamberRows, true);

    /* if calculations are not valid return */
    if (!calculations || !calculations.requestData) {
      return;
    }
    try {
      let volume = this.calculateVolume(calculations);
      this.props.setCalculatedVolume(volume, calculations.calculations, calculations.manifoldSizing);
    } catch (error) {
      console.error('Error in executeAutoCalculations:', error);
      this.setState({
        errorDialogHidden: false,
        errorDialogMessage: error.message,
      });
    }
  }

  computeStoneBedPerimeter(stoneBedPoints) {
    let perimeter = 0;
    /* closing the polygon */
    let polygonPoints = stoneBedPoints.slice();

    /* calculating perimeter */
    for (let i = 0; i < polygonPoints.length - 2; i += 2) {
      let xdist = Math.pow(polygonPoints[i + 2] - polygonPoints[i], 2);
      let ydist = Math.pow(polygonPoints[i + 3] - polygonPoints[i + 1], 2);
      perimeter += Math.sqrt(xdist + ydist);
    }
    /* convert to current scale square feets */
    perimeter = perimeter / (this.props.scalePixels / this.props.scaleValue);
    /* return the new stone bed area */
    return perimeter;
  }

  computeStoneBedArea(stoneBedPoints) {
    let points = [];
    for (let i = 0; i < stoneBedPoints.length - 2; i += 2) {
      let p = [stoneBedPoints[i], stoneBedPoints[i + 1]];
      points.push(p);
    }
    let area = calculatePolygonArea(points);
    /* convert to current scale square feets */
    area = area / Math.pow(this.props.scalePixels / this.props.scaleValue, 2);
    /* return the new stone bed area */
    return area;
  }

  computeUnderdrainSeparationDistance(stoneBedSeparation) {
    /* minimun separation distance is 1.6 feets */
    let minDist = 1.6;
    /* calculate the additional separation distance */
    let additionalSeparation = stoneBedSeparation / 12 >= minDist ? 0 : minDist - stoneBedSeparation / 12;

    return this.props.scalePixels * (additionalSeparation / this.props.scaleValue);
  }

  computeSeparationDistance(separation) {
    return this.props.scalePixels * (separation / 12 / this.props.scaleValue);
  }

  executeCalculations(chamberRows, useStatePoints) {
    /* the standard variables and constants */
    let numChambers = 0;
    let numEndCaps = 0;
    let activeRowsCnt = 0;
    let numIsoChambers = 0;
    let numIsoEndcaps = 0;
    let isoLengthInch = 0;
    const numberStubs = 3;
    const rollWidth = 17.5;
    const chamberType = this.props.chamberType;
    const chamberEndCapType = this.props.chamberEndCapType;
    const chamberRowSpacing = this.props.chamberRowSpacing;
    const porosityPercent = this.props.porosityPercent / 100;
    /* converting stone above and below to feets */
    const coverStoneHeight = this.props.porousStoneAbove / 12;
    const baseStoneHeight = this.props.porousStoneBelow / 12;

    /* count the number of chambers and endcaps */
    for (let i = 0; i < chamberRows.length; i++) {
      let activeChamberCnt = chamberRows[i].getActiveCount();
      let activeEndcapsCnt = chamberRows[i].countEndCaps();
      /* if there is any active chamber */
      if (activeChamberCnt) {
        activeRowsCnt++;
        numChambers += activeChamberCnt;
        numEndCaps += activeEndcapsCnt;
        const { isoChambers, isoEndcaps } = IsolatorService.getIsolatorQuantitiesForRow(chamberRows[i]);
        numIsoChambers += isoChambers;
        numIsoEndcaps += isoEndcaps;
      }
    }

    const inlets = ManifoldSelectors.getManifoldsByPurpose();
    let endCapScourInstances = 0;
    inlets.forEach((inlet) => {
      const addition = inlet._assembly.length - 1 + (inlet._manifoldSize.forceManifoldSpacer === true ? -1 : 0);
      endCapScourInstances += addition;
    });

    const tempStorageVolume =
      useStatePoints && this.props.totalStorageProvided ? this.props.totalStorageProvided : this.props.storageVolume;
    const manifoldSizing = getManifoldSizing(tempStorageVolume, chamberType);

    /* the values needed to compute the stone bed points */
    let sepDistancePixels = this.computeSeparationDistance(this.props.sepDistance);

    let { manifoldSeparations } = this.props.calculateManifoldSeparations(tempStorageVolume);
    /* default separation feets for underdrain is feets */
    let underDrainSepDistancePixels = this.computeUnderdrainSeparationDistance(this.props.sepDistance);

    /* determine if we need to recompute points or use the ones in state */
    let points;
    if (useStatePoints) {
      points = this.props.stoneBedPoints;
    } else {
      chamberRows = this.addOutlet(chamberRows);

      let { upperManifolds, lowerManifolds } = this.props.getManifoldMetadata(chamberRows);

      points = CalculationsLib.computePoints(
        null,
        chamberRows,
        this.props.chamberRowSpacingPixels,
        sepDistancePixels,
        underDrainSepDistancePixels,
        this.props.underdrain,
        manifoldSeparations,
        this.props.getManifolds(chamberRows, upperManifolds, true),
        this.props.getManifolds(chamberRows, lowerManifolds, false),
        this.props.sepDistance,
        this.props.chamberType,
        this.props.chamberRowSpacing,
        this.props.scalePixels,
        this.props.scaleValue,
      );
    }

    // Wall Height in inches
    let systemHeight = baseStoneHeight + chamberType.height + coverStoneHeight;

    /* calculate system length */
    let xCoords = points.filter((a, i) => i % 2 === 0);
    let xMin = Math.min(...xCoords);
    let xMax = Math.max(...xCoords);
    let _systemLength = Math.abs(xMin - xMax);
    let systemLength = _systemLength / (this.props.scalePixels / this.props.scaleValue);

    /* calculate system width */
    let yCoords = points.filter((a, i) => i % 2 !== 0);
    let yMin = Math.min(...yCoords);
    let yMax = Math.max(...yCoords);
    let _systemWidth = Math.abs(yMin - yMax);
    let systemWidth = _systemWidth / (this.props.scalePixels / this.props.scaleValue);

    /* the stone bed area and perimeter */
    let perimeter = this.computeStoneBedPerimeter(points);
    let area = this.computeStoneBedArea(points);
    // let area = systemLength * systemWidth;

    if (!useStatePoints) {
      // console.log("Calc. Area: ", area);
    } else {
      // console.log("Real Calc. Area: ", area);
    }

    let amountOfScourMaterial = numberStubs * chamberType.width + chamberRowSpacing * rollWidth;

    let totalExcavation = area * systemHeight;
    let remainingBackfillPavement = totalExcavation - coverStoneHeight * area * Math.pow(12, 2);

    let nonWovenRolls = 0;
    let wovenRolls = 0;
    let nonWovenBedAndLinerSqInch = 0;
    let nonWovenIsolatorSqInch = 0;
    let nonWovenSqInchOverage = 0;
    let wovenScourSqInch = 0;
    let wovenIsoSqInch = 0;
    let wovenSqInchOverage = 0;
    let linerSqInch = 0;
    let linerSqInchOverage = 0;
    try {
      const rollSqInchWoven = 648000;
      const rollSqInchNonWoven = 648000;
      const fabricOverage = 1.2;

      const wallAreaSqInch = perimeter * 12 * (systemHeight * 12);
      isoLengthInch =
        numIsoChambers * (chamberType.installedLength * 12) + numIsoEndcaps * (chamberEndCapType.installedLength * 12);
      const isoLengthFt = isoLengthInch / 12;

      // #region Geotextile non-woven

      //ft over the width of the arc of the chamber
      let nonWovenIsolatorSqFt =
        chamberType.id === CHAMBER_TYPE_ID_SC740
          ? isoLengthFt * 8
          : chamberType.id === CHAMBER_TYPE_ID_SC310
          ? isoLengthFt * 5
          : 0;

      linerSqInch = this.props.hasImperviousLiner ? area * 144 + wallAreaSqInch : 0;
      linerSqInchOverage = linerSqInch * fabricOverage;

      let nonWovenAroundBedSqInch = 2 * (area * 144) + wallAreaSqInch; //Fabric around bed

      nonWovenAroundBedSqInch = nonWovenAroundBedSqInch + linerSqInch;

      //NON-WOVEN (excluding Isolator Row)
      nonWovenBedAndLinerSqInch = nonWovenAroundBedSqInch * fabricOverage;
      //NON-WOVEN (Isolator Row)
      nonWovenIsolatorSqInch = nonWovenIsolatorSqFt * 144 * fabricOverage; //convert back to sq inches
      //TOTAL NON-WOVEN
      // let nonWovenSqInch = nonWovenBedAndLinerSqInch + nonWovenIsolatorSqInch;
      //TOTAL NON-WOVEN (including overage)
      nonWovenSqInchOverage = nonWovenBedAndLinerSqInch + nonWovenIsolatorSqInch; //included overage above

      //TOTAL NON-WOVEN (including overage) into ROLLS of fabric
      nonWovenRolls = Math.ceil(nonWovenSqInchOverage / rollSqInchNonWoven); //divide into rolls
      //#endregion

      // #region Geotextile woven
      // Most chamber types are 12.5 feet, MC series are 17.5 feet
      let scourLengthInch = (chamberType.id.indexOf('MC') > -1 ? 17.5 : 12.5) * 12;
      // Kelly Pulaski directed to use hard coded Scour Widths from BOM Spreadsheet (do not use Chamber Width and Row Gap)
      let widthOverIsoInch = 0; // Width is OVER the chamber from row gap to row gap
      let scourWidthInch = 0; // Width is UNDER the chamber from row gap to row gap
      switch (chamberType.id) {
        // case CHAMBER_TYPE_ID_SC160LP:
        //   widthOverIsoInch = 4 * 12; // 4 feet
        //   scourWidthInch = 3 * 12; // 3 feet
        //   break;
        // case CHAMBER_TYPE_ID_SC310:
        //   widthOverIsoInch = 4 * 12; // 4 feet
        //   scourWidthInch = 3.33 * 12; // 3.33 feet
        //   break;
        // case CHAMBER_TYPE_ID_SC740:
        // case CHAMBER_TYPE_ID_DC780:
        //   widthOverIsoInch = 5 * 12; // 5 feet
        //   scourWidthInch = 4.75 * 12; // 4.75 feet
        //   break;
        // case CHAMBER_TYPE_ID_MC3500:
        //   widthOverIsoInch = 8.75 * 12; // 8.75 feet
        //   scourWidthInch = 7.17 * 12; // 7.17 feet
        //   break;
        // case CHAMBER_TYPE_ID_MC4500:
        // case CHAMBER_TYPE_ID_MC7200:
        //   widthOverIsoInch = 17.5 * 12; // 17.5 feet
        //   scourWidthInch = 9.1 * 12; // 9.1 feet
        //   break;

        case CHAMBER_TYPE_ID_C100HD:
          widthOverIsoInch = 8.75 * 12; // 8.75 feet
          scourWidthInch = 7.17 * 12; // 7.17 feet
          break;
        default:
          break;
      }
      // WOVEN (excluding Isolator Row)
      //wovenScourSqInch = endCapScourInstances * scourWidthInch * scourLengthInch * fabricOverage;
      // WOVEN (Isolator Row)
      //wovenIsoSqInch = widthOverIsoInch * isoLengthInch * fabricOverage;
      // TOTAL WOVEN
      //let wovenSqInch = wovenIsoSqInch + wovenScourSqInch;
      // TOTAL WOVEN (including overage)
      //wovenSqInchOverage = wovenSqInch; // included overage above

      // TOTAL WOVEN (including overage) into ROLLS of fabric
      //wovenRolls = Math.ceil(wovenSqInchOverage / rollSqInchWoven); // divide into rolls
    } catch (ex) {
      console.log('Exception calculating geotextiles:', ex);
    }
    // #endregion

    let geoTextileQuantity = (area * 2 + perimeter * systemHeight) * 1.2;

    let totalChamberStorage = chamberType.storage * numChambers + chamberEndCapType.storage * numEndCaps;
    /* total excavation area is:
      perimeterStoneArea * the system height(stonebelow+stoneAbove+chamberHeight);
    */

    /* Total stone volume */
    let stoneAmountCalculated = totalExcavation - totalChamberStorage;
    let stoneVolumeCalculated = stoneAmountCalculated * porosityPercent;
    /* installed volume of the system */
    let installedStorageVolume = stoneVolumeCalculated + totalChamberStorage;

    /* add properties to calculations */
    let approximateTruckloads = Math.round((totalExcavation - totalChamberStorage) / 10);
    let stoneBackfill = totalExcavation * 12 - remainingBackfillPavement - totalChamberStorage;

    // woven calculations
    let wovenCalc = systemWidth * 2 * 1.1;
    let wovenIsolatorCalc = systemLength * 1.1;

    // non-woven calculations
    let nonWovenCalc = ((area * 2 + perimeter * systemHeight) * 1.4) / 9;
    let nonWovenIsolatorCalc = (isoLengthInch * (chamberType.width * 12) * 1.4) / 1296;

    /* the calculations object */
    const calculations = {
      installedStorageVolume,
      stoneAmountCalculated,
      stoneVolumeCalculated,
      approximateTruckloads,
      stoneBackfill,
      porosityPercent,
      totalChamberStorage,
      numRows: activeRowsCnt,
      numEndCaps: numEndCaps,
      numChambers: numChambers,
      systemLength: systemLength,
      systemWidth: systemWidth,
      area: area,
      systemHeight: systemHeight,
      // headerStorage: headerStorage,
      amountOfScourMaterial: amountOfScourMaterial,
      totalExcavation,
      remainingBackfillPavement: remainingBackfillPavement,
      perimeter: perimeter,
      linerSqInchOverage: this.props.hasImperviousLiner ? linerSqInchOverage / 1296 : 0,
      geoTextileQuantity: geoTextileQuantity,
      geotextileQuantities: {
        nonWoven: nonWovenCalc,
        //nonWovenIsolator: nonWovenIsolatorSqInch / 1296,
        nonWovenIsolator: nonWovenIsolatorCalc,
        // nonWovenTotal: nonWovenSqInchOverage / 1296,
        nonWovenTotal: nonWovenCalc + nonWovenIsolatorCalc,
        woven: wovenCalc,
        wovenIsolator: wovenIsolatorCalc,
        wovenTotal: wovenCalc + wovenIsolatorCalc,
        totalNonWovenRolls: nonWovenRolls,
        totalWovenRolls: wovenRolls,
        linerSqInchOverage,
      },
    };
    /* if any of the calculations is not a number, return and
    dont change the state */
    if (
      Object.keys(calculations)
        .filter((k) => k !== 'geotextileQuantities')
        .some((k) => {
          return isNaN(calculations[k]);
        })
    ) {
      return;
    }

    /* the request data */
    const requestData = {
      Type: chamberType.name,
      AreaOfSystem: calculations.area * 1.44,
      NumberOfEndCaps: calculations.numEndCaps,
      NumberOfChambers: calculations.numChambers,
      StonePorosity: porosityPercent, //hardcoded
      /* API accept inches, converting back */
      StoneAboveChambers: coverStoneHeight * 12,
      StoneBelowChambers: baseStoneHeight * 12,
    };

    /* return the calculations */
    return {
      requestData,
      calculations,
      manifoldSizing,
      manifoldSeparations,
    };
  }

  getExceededAlertText(param, minimumCover, maximumCover) {
    let msg = this.props.content[this.props.lang].msgDefault;
    switch (param) {
      case 'availableLength':
        msg = this.props.content[this.props.lang].msgExceedAvailableLength;
        break;
      case 'availableWidth':
        msg = this.props.content[this.props.lang].msgExceedAvailableWidth;
        break;
      case 'porousStoneAbove':
        msg = this.props.content[this.props.lang].msgExceedPorousStoneAbove;
        break;
      case 'porousStoneBelow':
        msg = this.props.content[this.props.lang].msgExceedPorousStoneBelow;
        break;
      case 'porosityPercent':
        msg = this.props.content[this.props.lang].msgExceedPorosityPercent;
        break;
      case 'averageCover':
        msg = this.props.content[this.props.lang].messageExceededCover
          .replace('_chamberName', this.props.chamberType.name)
          .replace('_minimumCover', `${minimumCover} ${this.props.lbl[this.props.unit].in[this.props.lang]}`)
          .replace('_maximumCover', `${maximumCover} ${this.props.lbl[this.props.unit].in[this.props.lang]}`);
        break;
      default:
        break;
    }
    return msg;
  }

  getBelowAlertText(param, minimumCover, maximumCover) {
    //TODO: Add alert text for baseStoneElevation (and another one above this)
    let msg = this.props.content[this.props.lang].msgDefault;
    switch (param) {
      case 'availableLength':
        msg = this.props.content[this.props.lang].msgBelowAvailableLength;
        break;
      case 'availableWidth':
        msg = this.props.content[this.props.lang].msgBelowAvailableWidth;
        break;
      case 'porousStoneAbove':
        msg = this.props.content[this.props.lang].msgBelowPorousStoneAbove;
        break;
      case 'porousStoneBelow':
        msg = this.props.content[this.props.lang].msgBelowPorousStoneBelow;
        break;
      case 'porosityPercent':
        msg = this.props.content[this.props.lang].msgBelowPorosityPercent;
        break;
      case 'averageCover':
        msg = this.props.content[this.props.lang].messageExceededCover
          .replace('_chamberName', this.props.chamberType.name)
          .replace('_minimumCover', `${minimumCover} ${this.props.lbl[this.props.unit].in[this.props.lang]}`)
          .replace('_maximumCover', `${maximumCover} ${this.props.lbl[this.props.unit].in[this.props.lang]}`);
        break;
      default:
        break;
    }
    return msg;
  }

  addOutlet(chamberRows) {
    if (this.props.hasOutlet) {
      try {
        chamberRows = cloneChamberRows(chamberRows);

        let lastChamberRow = chamberRows[chamberRows.length - 1];
        let lastActiveChamber = lastChamberRow.getLastActiveChamber();

        const outletManifoldAccessory = {
          id: OUTLET_MANIFOLD_ID,
          name: 'Outlet Manifold',
          description: 'ADS Outlet Manifold accessory',
          type: 'accessory',
          color: 'coral',
          variant: 'round',
          order: 2,
          for: { endcaps: true, chambers: false },
          exceptions: {},
        };

        lastChamberRow.modifyChamber(
          { lowerCapActive: true, lowerCapAccessory: outletManifoldAccessory },
          lastActiveChamber.col,
        );

        return chamberRows;
      } catch (exception) {
        console.warn(exception);
      }
    }
    return chamberRows;
  }

  /**
   * Convert Units
   * This one was taken out from render
   * @param {*} value
   * @param {*} unitType
   * @param {number} decimalPlaces
   */
  convertUnits(value, unitType, decimalPlaces = 2) {
    let unitValue = 0;
    switch (this.props.unit) {
      case METRIC:
        switch (unitType) {
          case 'ft': // Feet to meters
            return decimalPlaces > 2
              ? parseFloat((Math.round(value * 0.3048 * 1000) / 1000).toString()).toFixed(decimalPlaces)
              : parseFloat((Math.round(value * 0.3048 * 100) / 100).toString()).toFixed(2);
          case 'in': // Inches to millimeters
            return Math.round(Math.round(value * 25.4 * 100) / 100);
          case 'cf': // Cubic feet to cubic meters
            return parseFloat((Math.round((value / 35.315) * 100) / 100).toString()).toFixed(2);
          default:
            return Math.round(value * 100) / 100;
        }
      case IMPERIAL:
        return value;
      default:
        break;
    }
    return unitValue;
  }

  /**
   * Not really sure about the difference with convertUnits, but it handles the difference on Metric,
   * so, please do not change
   * @param value
   * @param unitType
   * @param decimalPlaces
   * @returns {number}
   */
  convertUnits2(value, unitType, decimalPlaces = 2) {
    let unitValue = 0;
    switch (this.props.unit) {
      case METRIC:
        switch (unitType) {
          case 'ft': // Feets to meters
            unitValue =
              decimalPlaces > 2
                ? parseFloat(Math.round((value / 0.3048) * 1000) / 1000).toFixed(decimalPlaces)
                : parseFloat(Math.round((value / 0.3048) * 100) / 100).toFixed(2);
            break;
          case 'in': // Inches to milimeters
            unitValue = Math.round((value / 25.4) * 100) / 100;
            break;
          case 'cf': // Cubic feets to cubic meters
            unitValue = parseFloat(Math.round(value * 35.315 * 100) / 100).toFixed(2);
            break;
          default:
            unitValue = Math.round(value * 100) / 100;
            break;
        }
        break;
      case IMPERIAL:
        unitValue = value;
        break;
      default:
        break;
    }
    return unitValue;
  }

  handleParameterValueOnValidate(param, lowBound, highBound, parseFunc, unitType, value) {
    if (isNaN(value)) {
      return `${this.convertUnits2(this.props[param], unitType)}`;
    }
    const allowsThreeDecimals = this.props.unit === METRIC && param === 'baseStoneElevation';
    /* parse value */
    value = this.props.unit === METRIC ? parseFunc(value) : this.roundNumber(parseFunc(value));

    /* if change is in bounds, compute and return */
    let newVal = this.convertUnits2(value, unitType, allowsThreeDecimals ? 3 : null);

    if (newVal < lowBound) {
      this.props.modalAlertActions({
        toggle: true,
        btnText: this.props.content[this.props.lang].cancel,
        secondButton: false,
        productType: GLOBAL_PROJECT_TYPE_CHAMBER,
        text: this.getBelowAlertText(param, lowBound, highBound),
      });
      newVal = lowBound;
      this.handleSetParameterValue(param, newVal);
    } else if (newVal > highBound) {
      this.props.modalAlertActions({
        toggle: true,
        btnText: this.props.content[this.props.lang].cancel,
        secondButton: false,
        productType: GLOBAL_PROJECT_TYPE_CHAMBER,
        text: this.getExceededAlertText(param, lowBound, highBound),
      });
      newVal = highBound;
      this.handleSetParameterValue(param, newVal);
    } else {
      this.handleSetParameterValue(param, newVal);
    }
    let displayResult = this.convertUnits(newVal, unitType, allowsThreeDecimals ? 3 : null);
    return `${displayResult}`;
  }

  handleOverallValueOnValidate(lowBound, highBound, parseFunc, unitType, value) {
    if (isNaN(value)) {
      return `${this.convertUnits2(this.props.multibedOverallSiteVolume, unitType)}`;
    }

    const allowsThreeDecimals = this.props.unit === METRIC;

    value = this.props.unit === METRIC ? parseFunc(value) : this.roundNumber(parseFunc(value));

    let newVal = this.convertUnits2(value, unitType, allowsThreeDecimals ? 3 : null);

    this.props.setOverallTotal(newVal);

    let displayResult = this.convertUnits(newVal, unitType, allowsThreeDecimals ? 3 : null);
    return `${displayResult}`;
  }

  handleSetParameterValue(param, newVal) {
    setTimeout(() => {
      return this.props.setParameterValue(param, newVal);
    });
  }

  handleUnderdrainOnclick() {
    this.props.switchUnderdrain();
  }

  handleCancelClearOnClick() {
    /* hide clear dialog */
    this.props.switchClearDialogVisibility(false);
  }

  handleConfirmClearOnClick() {
    this.props.resetBasicAppState();
  }

  generateSystem() {
    if (this.props.hasImperviousLiner) {
      setTimeout(() => {
        this.props.setParameterValue('hasImperviousLiner', true);
        this.props.setImperviousLiner(true);
      });
    }
    this.props.startSystemGeneration();
    this.props.switchIsSigningInProcess(false);
  }

  renderPopUpHelper(title, text, image) {
    return <PopUpHelper text={text} title={title} image={image} />;
  }

  calculateCoverValue(cover, unitType) {
    const result = this.convertUnits(parseFloat(this.props.baseStoneElevation) + cover, unitType);
    return this.props.unit === IMPERIAL ? result.toFixed(2) : result;
  }

  /**
   * Builds spin inputs for the menu
   * @param {string} param
   * @param {*} label
   * @param step
   * @param {*} parseFunc
   * @param disable
   * @param {*} text
   * @param {*} image
   * @param {*} unitType
   */
  renderConstrainedParam(param, label, step, parseFunc, disable, text, image, unitType, isLabel) {
    if (!this.props.chamberType || !this.props.minimums || !this.props.maximums) return;
    const minVal = this.props.minimums[param];
    const maxVal = this.props.maximums[param];
    let mainValue = 0;

    const clear =
      this.props.sysParam &&
      this.props.sysParam['loadedProject'] === true &&
      this.props.sysParam['touchedChambers'] === false;

    if (
      param === 'storageVolume' &&
      this.props.sysParam['pipeRequiredVolume'].touched &&
      this.props.sysParam['pipeRequiredVolume'].stamp > this.props.sysParam['storageVolume'].stamp
    ) {
      mainValue = this.props.sysParam['pipeRequiredVolume'].value;
    } else if (
      param === 'availableLength' &&
      this.props.sysParam['pipeAvailableLength'].touched &&
      this.props.sysParam['pipeAvailableLength'].stamp > this.props.sysParam['availableLength'].stamp
    ) {
      mainValue = this.props.sysParam['pipeAvailableLength'].value;
    } else if (
      param === 'availableWidth' &&
      this.props.sysParam['pipeAvailableWidth'].touched &&
      this.props.sysParam['pipeAvailableWidth'].stamp > this.props.sysParam['availableWidth'].stamp
    ) {
      mainValue = this.props.sysParam['pipeAvailableWidth'].value;
    } else if (
      param === 'porosityPercent' &&
      this.props.sysParam['pipeStonePorosity'].touched &&
      this.props.sysParam['pipeStonePorosity'].stamp > this.props.sysParam['porosityPercent'].stamp
    ) {
      mainValue = this.props.sysParam['pipeStonePorosity'].value;
    } else {
      if (this.props.sysParam[param] && this.props.sysParam[param].touched && this.props.sysParam[param].active) {
        mainValue = this.props.sysParam[param].value;
      } else {
        mainValue = this.props[param];
      }
    }

    if (clear) {
      mainValue = this.props[param];
    }

    return (
      <div className="ms-Grid-row" style={css.cpPadding}>
        <div
          className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl6 ms-xxl6"
          style={{ paddingLeft: '6px', paddingRight: '6px' }}>
          {label}
        </div>
        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl6 ms-xxl6" style={{ display: 'flex' }}>
          {isLabel ? (
            <div
              style={{
                width: '100%',
                height: '32px',
                fontWeight: '1000',
                paddingLeft: '12px',
              }}>
              {this.calculateCoverValue(
                param === 'maximumAllowableCover'
                  ? this.props.chamberType.maxCover
                  : this.props.chamberType.minInstalledDepth,
                unitType,
              )}
            </div>
          ) : (
            <SpinButton
              // step={step}
              max={`${this.convertUnits(maxVal, unitType)}`}
              min={minVal < 0 ? 0 : `${this.convertUnits(minVal, unitType)}`}
              value={this.convertUnits(
                mainValue,
                unitType,
                param === 'baseStoneElevation' && this.unit === METRIC ? 3 : 2,
              )}
              className={'hide-arrows'}
              disabled={disable}
              onValidate={this.handleParameterValueOnValidate.bind(this, param, minVal, maxVal, parseFunc, unitType)}
            />
          )}
          &nbsp;
          {this.renderPopUpHelper(label, text, image)}
        </div>
      </div>
    );
  }

  renderOverallSiteVolume(label, step, parseFunc, disable, text, image, unitType) {
    const minVal = 0;
    const maxVal = 1000000;

    let mainValue = this.props.multibedOverallSiteVolume;

    return (
      <div className="ms-Grid-row" style={css.cpPadding}>
        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl6 ms-xxl6">{label}</div>
        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl6 ms-xxl6" style={{ display: 'flex' }}>
          <SpinButton
            // step={step}
            max={`${this.convertUnits(maxVal, unitType)}`}
            min={minVal < 0 ? 0 : `${this.convertUnits(minVal, unitType)}`}
            value={this.convertUnits(mainValue, unitType, 2)}
            className={'hide-arrows'}
            disabled={disable}
            onValidate={this.handleOverallValueOnValidate.bind(this, minVal, maxVal, parseFunc, unitType)}
          />
          &nbsp;
          {this.renderPopUpHelper(label, text, image)}
        </div>
      </div>
    );
  }

  setPerimeterImperviousLiner(value) {
    if (value) {
      if (!ChamberBedSelectors.hasAnyActiveChambers()) {
        this.setState({ includeImperviousLinerWaring4: true });
        return null;
      }

      if (!ManifoldSelectors.bedHasOutlet()) {
        this.setState({ includeImperviousLinerWaringError: true });
        return null;
      }

      if (!this.props.underdrain) {
        this.setState({ includeImperviousLinerWaring2: true });
        return null;
      }

      this.setState({ includeImperviousLinerWaring1: true });
    } else {
      this.props.setParameterValue('hasImperviousLiner', false);
      this.props.setImperviousLiner(false);
    }
  }

  render() {
    const { changeColor } = this.state;

    const { lbl, unit, lang, content, projectType, switchIsSigningInProcess } = this.props;

    // Render the calculations panel
    const showInfo = (title, text, image, chamberImg, type) => {
      return <PopUpHelper text={text} title={title} image={image} type={type} chamber={chamberImg} />;
    };

    const handleClearButtonClick = () => {
      this.props.switchClearDialogVisibility(true);
    };

    const generateChambers = () => {
      this.props.setShowGenerateAlert(false);
      switchIsSigningInProcess(true);
      setTimeout(() => {
        if (this.props.hasOutlet && !this.props.underdrain && this.props.user === null) {
          this.handleUnderdrainOnclick();
        }
        this.generateSystem();
      }, 10);
    };

    const generatePipes = () => {
      switchIsSigningInProcess(true);
      this.props.setShowGenerateAlert(false);
      setTimeout(() => {
        switchIsSigningInProcess(false);
      }, 1000);

      // TODO: Create two versions of the calculation component
      this.props.generatePipeDesign();
    };

    const modalActionsConfirm = () => {
      this.setState({ showModalConfirm: false });
    };

    const customModalActionsConfirm = () => {
      this.setState({
        customModal: {
          ...this.INITIAL_LOCAL_STATE.customModal,
        },
      });
    };

    let crossSectionPrefix = this.props.lang.substring(0, 2);
    if (crossSectionPrefix === 'fr' && this.props.region.id === regionIds.europe) crossSectionPrefix += 'FR';

    return (
      <BlockUi tag="div" className="Calculations" blocking={this.state.optimizing}>
        <div
          style={css.card}
          ref={(node) => {
            this.paramsNode = node;
          }}>
          <div className="ms-Grid-row">
            {this.props.projectType === GLOBAL_PROJECT_TYPE_CHAMBER && this.props.chamberType ? (
              <React.Fragment>
                <div
                  className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl6 ms-xxl6"
                  style={{ textAlign: 'left', padding: '3px' }}>
                  <div>
                    <strong>{content[lang].selectChamberType}</strong>
                  </div>
                  <div style={{ paddingTop: '20px' }}>
                    <AppToolbar />
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl6 ms-xxl6" style={{ textAlign: 'center' }}>
                  {this.props.chamberType !== null
                    ? showInfo(
                        this.props.chamberType.name,
                        content[lang][`${this.props.chamberType.name.replace(/-/g, '')}`],
                        require(`../../media/chambers/${crossSectionPrefix}/${this.props.chamberType.id}_CrossSection.png`),
                        require(`../../media/chambers/${this.props.chamberType.id}.png`),
                        'crossSection',
                      )
                    : null}
                </div>

                {this.props.isMultiBedProject
                  ? this.renderOverallSiteVolume(
                      `${content[lang].overallSiteVolume} (${lbl[unit].cf[lang]})`,
                      500,
                      parseFloat,
                      false,
                      content[lang].enterOverallSiteVolume,
                      null,
                      'cf',
                    )
                  : null}

                {this.renderConstrainedParam(
                  'storageVolume',
                  `${content[lang].storageVolume} (${lbl[unit].cf[lang]})`,
                  500,
                  parseFloat,
                  false,
                  content[lang].enterTheStorageVolume,
                  null,
                  'cf',
                )}

                {this.renderConstrainedParam(
                  'availableLength',
                  `${content[lang].availableLength} (${lbl[unit].ft[lang]})`,
                  10,
                  parseFloat,
                  false,
                  content[lang].enterAvailableLengthChambers,
                  null,
                  'ft',
                )}
                {this.renderConstrainedParam(
                  'availableWidth',
                  `${content[lang].availableWidth} (${lbl[unit].ft[lang]})`,
                  10,
                  parseFloat,
                  false,
                  content[lang].enterAvailableWidthChambers,
                  null,
                  'ft',
                )}
                {this.renderConstrainedParam(
                  'porousStoneAbove',
                  `${content[lang].stoneAboveChambers} (${lbl[unit].in[lang]})`,
                  1,
                  parseFloat,
                  false,
                  content[lang].enterTheAmountOfStoneAboveChambers,
                  STONE_ABOVE_TABLE,
                  'in',
                )}
                {this.renderConstrainedParam(
                  'porousStoneBelow',
                  `${content[lang].stoneBelowChambers} (${lbl[unit].in[lang]})`,
                  1,
                  parseFloat,
                  false,
                  content[lang].enterTheAmountOfStoneBelowChambers,
                  STONE_BELOW_TABLE,
                  'in',
                )}
                {this.renderConstrainedParam(
                  'baseStoneElevation',
                  `${content[lang].baseStoneElevation} (${lbl[unit].ft[lang]})`,
                  1,
                  parseFloat,
                  false,
                  content[lang].enterTheBottomOfStoneElevation,
                  null,
                  'ft',
                )}
                {this.renderConstrainedParam(
                  'porosityPercent',
                  content[lang].stonePorosity,
                  1,
                  parseFloat,
                  false,
                  content[lang].enterStonePorosity,
                  null,
                  null,
                )}
                {this.renderConstrainedParam(
                  'maximumAllowableCover',
                  `${content[lang].maximumAllowableCover} (${lbl[unit].ft[lang]})`,
                  1,
                  parseFloat,
                  false,
                  content[lang].maximumAllowableCoverInstructions,
                  null,
                  'ft',
                  true,
                )}
                {this.renderConstrainedParam(
                  'minimumAllowableCover',
                  `${content[lang].minimumAllowableCover} (${lbl[unit].ft[lang]})`,
                  1,
                  parseFloat,
                  false,
                  content[lang].minimumAllowableCoverInstructions,
                  null,
                  'ft',
                  true,
                )}
                <br />

                {/*This toggle is duplicated, the second toggle is only a fake prop on screen */}
                {/*{this.props.user ? (
                  <Toggle
                    disabled={!this.props.hasCornerOutlet && !this.props.hasPerimeterOutlet}
                    className="Toggle ms-Toggle_green_back"
                    onClick={() => {
                      this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                      if (this.props.hasImperviousLiner) {
                        if (this.props.underdrain) {
                          this.setState({ includeImperviousLinerWaring3: true });
                        } else {
                          this.handleUnderdrainOnclick();
                        }
                      } else {
                        this.handleUnderdrainOnclick();
                      }
                    }}
                    checked={this.props.underdrain && (this.props.hasCornerOutlet || this.props.hasPerimeterOutlet)}
                    onText={content[lang].includeUnderdrainYes}
                    offText={content[lang].includeUnderdrainNo}
                  />
                ) : (
                  <div
                    onClick={() => {
                      if (!this.props.user) {
                        this.props.setDisableLayerLoginDialog(true);
                      }
                    }}>
                    <Toggle
                      disabled={true}
                      className="Toggle ms-Toggle_green_back"
                      checked={this.props.underdrain && (this.props.hasCornerOutlet || this.props.hasPerimeterOutlet)}
                      onText={content[lang].includeUnderdrainYes}
                      offText={content[lang].includeUnderdrainNo}
                    />
                  </div>
                )}



                <Toggle
                  className="Toggle ms-Toggle_green_back"
                  onClick={() => {
                    this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                  }}
                  checked={this.props.hasOutlet}
                  onChange={(event, value) => this.props.setParameterValue('hasOutlet', value)}
                  onText={content[lang].includeOutletYes}
                  offText={content[lang].includeOutletNo}
                />



                <div
                  onClick={() => {
                    if (!this.props.user) {
                      this.props.setDisableLayerLoginDialog(true);
                    }
                  }}>
                  <Toggle
                    className="Toggle ms-Toggle_green_back"
                    onClick={() => {
                      this.props.clearRulersOnScreen();
                    }}
                    checked={this.props.hasImperviousLiner}
                    onChange={(event, value) => this.setPerimeterImperviousLiner(value)}
                    onText={content[lang].includeImperviousLinerYes}
                    offText={content[lang].includeImperviousLinerNo}
                    disabled={!this.props.user ? 'disabled' : ''}
                  />
                </div>*/}
                <Toggle
                  className="Toggle ms-Toggle_green_back"
                  onClick={() => {
                    this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                  }}
                  checked={this.props.hasOutlet}
                  onChange={(event, value) => this.props.setParameterValue('hasOutlet', value)}
                  onText={content[lang].includeOutletYes}
                  offText={content[lang].includeOutletNo}
                />
              </React.Fragment>
            ) : (
              <div style={css.cpPadding}>
                <PipeParameters />
              </div>
            )}
          </div>
          <br />
          {/* Buttons on scree for generation */}
          <div style={{ textAlign: 'center' }}>
            <DefaultButton
              disabled={this.props.availableLength === 0 || this.props.availableWidth === 0}
              primary={true}
              text={content[lang].generateDesign}
              onClick={() => {
                this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                this.props.setShowGenerateAlert(true);
              }}
              style={{ width: '160px' }}
            />
            <div style={{ height: '10px' }} />
            <DefaultButton
              checked={false}
              disabled={false}
              data-automation-id="delete"
              text={content[lang].resetDesign}
              onClick={() => {
                this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                handleClearButtonClick();
              }}
              style={{
                ...(changeColor ? css.default : css.changed),
                width: '160px',
              }}
              onMouseLeave={() => this.setState({ changeColor: true })}
              onMouseEnter={() => this.setState({ changeColor: false })}
              // className="ms-bgColor-red ms-bgColor-redDark--hover ms-fontColor-white ms-fontColor-white--hover"
            />
          </div>
          <br />
        </div>
        <Dialog
          hidden={this.state.errorDialogHidden}
          dialogContentProps={{
            type: DialogType.normal,
            title: content[lang].calculationError,
            subText: `${content[lang].unexpectedErrorOcurred} ${this.state.errorDialogMessage}`,
          }}
          modalProps={{
            isBlocking: true,
            containerClassName: 'ms-dialogMainOverride',
          }}>
          <DialogFooter>
            <PrimaryButton
              text={content[lang].ok}
              onClick={() => {
                this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                this.setState(this.INITIAL_LOCAL_STATE);
              }}
            />
          </DialogFooter>
        </Dialog>
        {this.props.showGenerateAlert ? (
          <PopUpHelper
            title={content[lang].yes}
            type="alert"
            show={this.props.showGenerateAlert}
            modalActions={projectType === GLOBAL_PROJECT_TYPE_CHAMBER ? generateChambers : generatePipes}
            hideModal={() => this.props.setShowGenerateAlert(false)}
            text={content[lang].thisWillReplaceCurrentDesign}
          />
        ) : null}
        {this.state.showModalConfirm ? (
          <PopUpHelper
            title={content[lang].ok}
            type="alert"
            modalSize="mid"
            show={this.state.showModalConfirm}
            modalActions={modalActionsConfirm}
            hideModal={() => this.setState({ showModalConfirm: false })}
            text={
              <div
                style={{
                  textAlign: lang === languageIds.deDE ? 'left' : 'justify',
                }}>
                {content[lang].providedAvailableLengthAndWidth}
                <ul>
                  <li>{content[lang].stoneAboveChambersMsg}</li>
                  <li>{content[lang].stoneBelowChambersMsg}</li>
                  <li>{content[lang].selectLargerChamberModel}</li>
                </ul>
              </div>
            }
          />
        ) : null}
        {this.state.customModal.show ? (
          <PopUpHelper
            type="alert"
            modalSize="small"
            text={this.state.customModal.text}
            show={this.state.customModal.show}
            title={this.state.customModal.title}
            hideModal={customModalActionsConfirm}
            modalActions={customModalActionsConfirm}
          />
        ) : null}
        <Dialog
          hidden={!this.props.showEraseDialog}
          dialogContentProps={{
            type: DialogType.normal,
            title: content[lang].clearApplication,
            subText: content[lang].theApplicationWillBeReloaded,
          }}
          modalProps={{
            isBlocking: true,
            containerClassName: 'ms-dialogMainOverride',
          }}>
          <DialogFooter>
            <PrimaryButton
              onClick={() => {
                this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                this.handleConfirmClearOnClick();
              }}
              text={content[lang].yes}
            />
            <DefaultButton
              onClick={() => {
                this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                this.handleCancelClearOnClick();
              }}
              text={content[lang].cancel}
              className={'outline_grey_ads'}
            />
          </DialogFooter>
        </Dialog>

        {/*before adding liner*/}
        <Dialog
          hidden={!this.state.includeImperviousLinerWaring1}
          dialogContentProps={{
            type: DialogType.normal,
            title: content[lang].imperviousLinerDialogNonCommonTitle,
            subText: content[lang].imperviousLinerDialogNonCommon,
          }}
          modalProps={{
            isBlocking: false,
            containerClassName: 'alert-level-container alert-level-2-container',
          }}>
          <DialogFooter>
            <PrimaryButton
              onClick={() => {
                this.props.clearRulersOnScreen();
                this.setState({ includeImperviousLinerWaring1: false });
                this.props.setParameterValue('hasImperviousLiner', true);
                this.props.setImperviousLiner(true);
              }}
              text={content[lang].ok}
            />
            <DefaultButton
              onClick={() => {
                this.props.clearRulersOnScreen();
                this.setState({ includeImperviousLinerWaring1: false });
                this.props.setParameterValue('hasImperviousLiner', false);
                this.props.setImperviousLiner(false);
              }}
              text={content[lang].cancel}
              className={'outline_grey_ads'}
            />
          </DialogFooter>
        </Dialog>

        <Dialog
          hidden={!this.state.includeImperviousLinerWaring2}
          dialogContentProps={{
            type: DialogType.normal,
            title: content[lang].imperviousLinerDialogPotentialDeadStorageTitle,
            subText: content[lang].imperviousLinerDialogPotentialDeadStorage,
          }}
          modalProps={{
            isBlocking: false,
            containerClassName: 'alert-level-container alert-level-2-container',
          }}>
          <DialogFooter>
            <PrimaryButton
              onClick={() => {
                this.props.clearRulersOnScreen();
                this.setState({ includeImperviousLinerWaring2: false });
                this.props.setParameterValue('hasImperviousLiner', true);
                this.props.setImperviousLiner(true);
              }}
              text={content[lang].ok}
            />
            <DefaultButton
              onClick={() => {
                this.props.clearRulersOnScreen();
                this.setState({ includeImperviousLinerWaring2: false });
                this.props.setParameterValue('hasImperviousLiner', false);
              }}
              text={content[lang].cancel}
              className={'outline_grey_ads'}
            />
          </DialogFooter>
        </Dialog>

        <Dialog
          hidden={!this.state.includeImperviousLinerWaringError}
          dialogContentProps={{
            type: DialogType.normal,
            title: content[lang].imperviousLinerWarningTitle,
            subText: content[lang].imperviousLinerWarning,
          }}
          modalProps={{
            isBlocking: false,
            containerClassName: 'alert-level-container alert-level-3-container',
          }}>
          <DialogFooter>
            <DefaultButton
              onClick={() => {
                this.props.clearRulersOnScreen();
                this.setState({ includeImperviousLinerWaringError: false });
                this.props.setParameterValue('hasImperviousLiner', false);
              }}
              text={content[lang].cancel}
              className={'outline_grey_ads'}
            />
          </DialogFooter>
        </Dialog>

        {/*before removing underdrain*/}
        <Dialog
          hidden={!this.state.includeImperviousLinerWaring3}
          dialogContentProps={{
            type: DialogType.normal,
            title: content[lang].imperviousLinerDialogPotentialDeadStorageTitle,
            subText: content[lang].imperviousLinerDialogPotentialDeadStorage,
          }}
          modalProps={{
            isBlocking: false,
            containerClassName: 'alert-level-container alert-level-2-container',
          }}>
          <DialogFooter>
            <PrimaryButton
              onClick={() => {
                this.props.clearRulersOnScreen();
                this.setState({ includeImperviousLinerWaring3: false });
                this.handleUnderdrainOnclick();
              }}
              text={content[lang].ok}
            />
            <DefaultButton
              onClick={() => {
                this.props.clearRulersOnScreen();
                this.setState({ includeImperviousLinerWaring3: false });
              }}
              text={content[lang].cancel}
              className={'outline_grey_ads'}
            />
          </DialogFooter>
        </Dialog>

        {/*Used to request a bed in order to add liner*/}
        <Dialog
          hidden={!this.state.includeImperviousLinerWaring4}
          dialogContentProps={{
            type: DialogType.normal,
            title: content[lang].titleWarning,
            subText: content[lang].imperviousLinerDialogNeedsBed,
          }}
          modalProps={{
            isBlocking: false,
            containerClassName: 'alert-level-container alert-level-2-container',
          }}>
          <DialogFooter>
            this.props.clearRulersOnScreen();
            <DefaultButton
              onClick={() => {
                this.setState({ includeImperviousLinerWaring4: false });
                this.props.setParameterValue('hasImperviousLiner', false);
              }}
              text={content[lang].cancel}
              className={'outline_grey_ads'}
            />
          </DialogFooter>
        </Dialog>
      </BlockUi>
    );
  }
}

const css = {
  card: {
    margin: '10px',
    height: '100%',
    textAlign: 'left',
  },
  cpPadding: {
    paddingTop: '10px',
  },
  default: {
    color: 'white',
    minWidth: '40px',
    backgroundColor: '#FF0000',
  },
  changed: {
    color: 'white',
    minWidth: '40px',
    backgroundColor: '#b30000',
  },
};

const mapStateToProps = (state) => {
  return {
    content: state.localization.content,
    isSigningIn: state.authentication.isSigningIn,
    lang: state.localization.lang,
    lbl: state.localization.lbl,
    region: state.localization.region,
    unit: state.localization.unit,
    user: state.authentication.user,

    /* Globals */
    chamberEndCapType: state.globals.chamberEndCapType,
    chamberRowSpacing: state.globals.chamberRowSpacing,
    chamberRowSpacingPixels: state.globals.chamberRowSpacingPixels,
    chamberType: state.globals.chamberType,
    enableDebugging: state.globals.enableDebuging,
    projectType: state.globals.projectType,
    scalePixels: state.globals.scalePixels,
    scaleValue: state.globals.scaleValue,

    /* Calculations */
    approximateTruckloads: state.calculations.approximateTruckloads,
    availableLength: state.calculations.availableLength,
    availableWidth: state.calculations.availableWidth,
    averageCover: state.calculations.averageCover,
    baseStoneElevation: state.calculations.baseStoneElevation,
    chamberStorage: state.calculations.chamberStorage,
    endUnits: state.calculations.endUnits,
    generateSystem: state.calculations.generateSystem,
    geotextileQuantity: state.calculations.geotextileQuantity,
    geotextileQuantities: state.calculations.geotextileQuantities,
    hasOutlet: state.calculations.hasOutlet,
    hasImperviousLiner: state.calculations.hasImperviousLiner,
    manifoldSize: state.calculations.manifoldSize,
    maximums: state.calculations.maximums,
    middleUnits: state.calculations.middleUnits,
    minimums: state.calculations.minimums,
    numberOfRows: state.calculations.numberOfRows,
    optimizeVolume: state.calculations.optimizeVolume,
    percentageOfStorageProvided: state.calculations.percentageOfStorageProvided,
    perimeter: state.calculations.perimeter,
    porosityPercent: state.calculations.porosityPercent,
    porousStoneAbove: state.calculations.porousStoneAbove,
    porousStoneBelow: state.calculations.porousStoneBelow,
    porousStoneStorage: state.calculations.porousStoneStorage,
    rectangularFootprint: state.calculations.rectangularFootprint,
    requiredChambers: state.calculations.requiredChambers,
    requiredEndCaps: state.calculations.requiredEndCaps,
    scourProtectionFitting: state.calculations.scourProtectionFitting,
    selectedTabKey: state.calculations.selectedTabKey,
    startUnits: state.calculations.startUnits,
    storageVolume: state.calculations.storageVolume,
    structureDistance: state.calculations.structureDistance,
    structureSize: state.calculations.structureSize,
    systemHeight: state.calculations.systemHeight,
    systemLength: state.calculations.systemLength,
    systemWidth: state.calculations.systemWidth,
    totalExcavation: state.calculations.totalExcavation,
    totalStorageProvided: state.calculations.totalStorageProvided,
    underdrain: state.calculations.underdrain,
    showGenerateAlert: state.calculations.showGenerateAlert,

    /* Stonebed */
    stoneBedPoints: state.stonebed.points,
    sepDistance: state.stonebed.sepDistance,
    manifoldStructures: state.stonebed.manifoldStructures,
    manifoldPipeSizes: state.stonebed.manifoldPipeSizes,
    manifoldSepDistanceFeets: state.stonebed.manifoldSepDistanceFeets,

    /* chamber bed properties */
    chamberRows: state.chamberbed.chamberRows,
    hasCornerOutlet: state.chamberbed.hasCornerOutlet,
    hasPerimeterOutlet: ManifoldSelectors.getManifoldsByPurpose('outlet').find((m) => m.isManifoldInner),

    upperManifolds: ManifoldSelectors.getManifoldsByType('upper'),
    lowerManifolds: ManifoldSelectors.getManifoldsByType('lower'),

    projectInfo: state.project.projectInfo,
    project: state.project.project,
    showProjectsModal: state.projectsCrud.showProjectsCrudModal,
    showProjectsAdminModal: state.projectsAdmin.showProjectsAdminModal,

    /* background map to props */
    backgroundImage: state.background.bgImg,

    /* Apptoolbar */
    rerunCalculations: state.apptoolbar.showLegacyComponentDialog,
    showEraseDialog: state.apptoolbar.showEraseDialog,
    accessories: state.apptoolbar.accessories,

    // System parameters (left menu state)
    sysParam: state.systemParameters,

    isMultiBedProject: ProjectSelectors.isMultiBedProject(),
    multibedOverallSiteVolume: state.multiBed.overallSiteVolume,
  };
};

const mapDispatchToProps = {
  getManifolds,
  resetAppState,
  resetBasicAppState,
  getScaledValue,
  setConstraints,
  switchUnderdrain,
  modalAlertActions,
  setParameterValue,
  switchProductType,
  endVolumeOptimizer,
  generatePipeDesign,
  getManifoldMetadata,
  setCalculatedVolume,
  switchPorousStorage,
  startVolumeOptimizer,
  startSystemGeneration,
  switchIsSigningInProcess,
  applyManifoldSeparations,
  setResultingOptimizedRows,
  switchClearDialogVisibility,
  calculateManifoldSeparations,
  clearRulersOnScreen,
  setShowGenerateAlert,
  switchCreateDialogVisibility,
  setImperviousLiner,
  setDisableLayerLoginDialog,
  setOverallTotal
};

export default connect(mapStateToProps, mapDispatchToProps)(Calculations);



// WEBPACK FOOTER //
// ./src/components/Calculations/index.js